import { applyMiddleware, createStore, AnyAction } from 'redux';

import { useDispatch } from 'react-redux';
import { persistStore } from 'redux-persist';
import thunk, { ThunkDispatch, ThunkAction } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import rootReducer, { IAppState } from '@store/reducers';

const middleWare = applyMiddleware(thunk);

export const store = createStore(rootReducer, composeWithDevTools(middleWare));

export const persistor = persistStore(store);

export type ReduxDispatch = ThunkDispatch<IAppState, Record<string, unknown>, AnyAction>;
export type ReduxAction<T> = ThunkAction<T, IAppState, Record<string, unknown>, AnyAction>;

export function useReduxDispatch(): ReduxDispatch {
    return useDispatch<ReduxDispatch>();
}
